<template>
  <modal
    title="Create New Collection"
    :open="open"
    @close="closeModal"
  >
    <form @submit.stop.prevent="submit">
      <text-input
        v-model.trim="name"
        label="Collection Name"
        maxlength="50"
      />

      <div class="button-row">
        <btn
          type="submit"
          :loading="submitting"
          :disabled="disabled"
          loading-text="Submitting"
        >
          Create
        </btn>

        <btn kind="secondary" @click="closeModal">
          Cancel
        </btn>
      </div>
    </form>
  </modal>
</template>

<script>
import { mapState } from 'vuex';
import * as Sentry from '@sentry/vue';

import { authService } from '@/services';

export default {
  props: {
    open: Boolean,
  },

  data() {
    return {
      name: '',
      submitting: false,
    };
  },

  computed: {
    ...mapState({
      user: (state) => state.user,
    }),

    disabled() {
      return !this.name;
    },
  },

  methods: {
    async submit() {
      this.submitting = true;

      try {
        const newCollection = await authService.createCollection(this.user.uid, this.name);

        this.$emit('create', newCollection);
        this.$toasted.success('Created a new collection!');
        this.closeModal();
      } catch (e) {
        this.$toasted.error('Error creating your new collection');
        Sentry.captureException(e);
      }

      this.submitting = false;
    },

    closeModal() {
      this.$emit('close');
    },
  },
};
</script>
